require('./vendor/slick.min');

require('./app/config');
require('./app/helpers');
require('./app/global');
require('./app/tabs');